module.exports = __webpack_public_path__ + "img/hn.94abe2f4.svg";